import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: "",
  loading: false,
  error: false,
  token: "",
  userId: "",
  email: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    registerSuccess: (state, { payload }) => {
      state.loading = false;
      state.user = payload.data.username;
      state.userId = payload.data._id;
      state.email = payload.data.email;

      state.token = payload.token;
    },
    loginSuccess: (state, { payload }) => {
      state.loading = false;
      state.token = payload.token;
      state.user = payload.user.username;
    },
    logoutSuccess: (state) => {
      state.token = "";
      state.user = "";
    },
  },
});

export const { registerSuccess, loginSuccess, logoutSuccess } =
  authSlice.actions;

export default authSlice.reducer;
